import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { BRAND } from '../brand';

/**
 * Fallback fail-closed para superficies de envío que aún tienen lógica hardcodeada
 * a un corredor que la marca actual no ofrece. Preferimos mostrar este mensaje
 * antes que exponer una cotización con datos de otra marca.
 */
const SendUnavailable = () => {
  const wa = BRAND?.whatsapp || '';
  const waHref = wa ? `https://wa.me/${wa}` : null;
  const brandPrimary = BRAND?.theme?.primary || '#111';

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between">
          <Link
            to="/dashboard"
            className="flex items-center gap-1.5 text-slate-600 hover:text-slate-900 text-sm font-medium"
            data-testid="send-unavailable-back"
          >
            <ArrowLeft size={18} />
            Volver
          </Link>
          <span className="text-sm font-bold text-slate-800">{BRAND.name}</span>
          <div className="w-14" />
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 pt-10 pb-24 flex-1">
        <div
          className="rounded-2xl bg-white border border-slate-200 shadow-sm p-6"
          data-testid="send-unavailable-card"
        >
          <h1 className="text-xl font-bold text-slate-900 mb-3" data-testid="send-unavailable-title">
            Envío desde la web en preparación
          </h1>
          <p className="text-sm text-slate-600 mb-5">
            Estamos habilitando el envío por autoservicio para tu corredor. Mientras tanto,
            coordina tu transferencia por WhatsApp con nuestro equipo — te atendemos al momento.
          </p>

          {waHref && (
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-2 text-white font-bold py-3.5 rounded-xl transition hover:opacity-90"
              style={{ background: brandPrimary }}
              data-testid="send-unavailable-whatsapp"
            >
              <MessageCircle size={18} />
              Escribir por WhatsApp
            </a>
          )}

          <Link
            to="/dashboard"
            className="block text-center text-sm text-slate-500 mt-4"
            data-testid="send-unavailable-dashboard"
          >
            Volver al panel
          </Link>
        </div>
      </main>
    </div>
  );
};

export default SendUnavailable;
